<template>
<el-card shadow="never" :body-style="{ padding: '20px' }" class="mb-4 mx-auto">
    <div class="mx-auto p-1 text-gray-600">
        <h2 class="text-2xl mb-4">FAQ</h2>
        <div class="mb-4">
            <h3 class="font-bold mb-1">What is Ashemaletube Downloader?</h3>
            <p>
                Ashemaletube Downloader is a free Chrome extension that lets you download videos from Ashemaletube for offline viewing. Save videos in their original quality to watch anytime.
            </p>
        </div>

        <div class="mb-4">
            <h3 class="font-bold mb-1">How does Ashemaletube Downloader work?</h3>
            <p>
                The downloader works through a Chrome browser extension that extracts video URLs from Ashemaletube pages. Simply paste the video URL into the downloader, and it will locate and prepare the video for download.
            </p>
        </div>

        <div class="mb-4">
            <h3 class="font-bold mb-1">Is Ashemaletube Downloader free?</h3>
            <p>
                Yes, Ashemaletube Downloader is completely free to use. Just install the Chrome extension and start downloading videos without any hidden fees or subscription requirements.
            </p>
        </div>

        <div>
            <h3 class="font-bold mb-1">Can I download multiple videos at once?</h3>
            <p>
                Yes, the downloader supports batch downloads. You can queue multiple Ashemaletube videos and download them sequentially, saving time when collecting multiple videos.
            </p>
        </div>
    </div>
</el-card>
</template>

<script>
export default {

}
</script>

<style>

</style>
